import * as React from 'react';
import * as cx from 'classnames';

export interface Props {
  name: string;
  size?: number;
  fixWidth?: boolean;
  className?: string;
  inverse?: boolean;
  spin?: boolean;
  pulse?: boolean;
  stack?: number;
}

const Icon: React.SFC<Props> = ({
  name,
  size = 1,
  fixWidth = false,
  className,
  spin = false,
  inverse = false,
  pulse = false,
  stack,
  ...rest
}) => {
  const iconClass = cx(
    'fa',
    `fa-${name}`,
    `fa-${size}x`,
    stack ? `fa-stack-${stack}x` : '',
    {
      'fa-fix-width': fixWidth,
      'fa-spin': spin,
      'fa-pulse': pulse,
      'fa-inverse': inverse,
    },
    className,
  );

  return <i className={iconClass} {...rest} />;
};

export default Icon;
